import { CustomForm } from 'components/form/customForm'
import { ImageUploadSection } from 'components/imageUploadSection'
import { useConfirmDialog } from 'hooks/admin/useConfirmDialog'
import { useEventsForm } from 'hooks/admin/useEvents'
import React, { useEffect, useState } from 'react'
import { SeatSellingMode, SeatSellingModes } from 'types/Event'
import { LocationType } from 'types/Location'
import { formatDate } from 'utils/event'

import { EventPricing } from '../pricing/EventPricing'
import { EventDataFields } from './eventDataFields'

interface EventFormProps {
    initialData?: Record<string, any>
    locationData?: LocationType
    generatedEventId?: string
    onClose?: () => void
    formRef?: React.RefObject<HTMLFormElement>
    partnerId?: string
}

export const EventForm: React.FC<EventFormProps> = ({ initialData, locationData, generatedEventId, onClose, formRef, partnerId }) => {
    const { show: showConfirmDialog, DialogComponent: ConfirmDialog } = useConfirmDialog()
    const [seatSellingMode, setSeatSellingMode] = useState<SeatSellingMode>(SeatSellingModes.SeatBased)

    const {
        control,
        handleSubmit,
        errors,
        loading,
        ticketData,
        setTicketData,
        customImage,
        setCustomImage,
        customImageOptions,
        setCustomImageOptions,
        onUpload,
        setValue,
        setUploadedImages,
    } = useEventsForm({
        initialData,
        locationData,
        generatedEventId,
        isEditMode: !!initialData,
        onClose,
        showConfirmDialog,
        partnerId,
        seatSellingMode,
    })

    const defaultPrice = 2500
    const defaultIncrement = 1000

    const [selectedPrice, setSelectedPrice] = useState<number | null>(defaultPrice)
    const [selectedPriceIndex, setSelectedPriceIndex] = useState<number | null>(0)

    useEffect(() => {
        if (initialData) {
            const { selling_start_date, selling_end_date, event_date, description, social_media_link, custom_image, seat_selling_mode } =
                initialData
            setValue('selling_start_date', formatDate(selling_start_date) || '')
            setValue('selling_end_date', formatDate(selling_end_date) || '')
            setValue('event_date', formatDate(event_date) || '')
            setValue('description', description || '')
            setValue('social_media_link', social_media_link || '')
            setValue('custom_image', custom_image || '')
            setSeatSellingMode(seat_selling_mode ?? locationData?.default_seat_selling_mode)
        }
    }, [initialData, setValue, locationData?.default_seat_selling_mode])

    return (
        <CustomForm
            handleSubmit={handleSubmit}
            loading={loading}
            initialData={initialData}
            onClose={onClose}
            hasLine={false}
            disableButtons={true}
            formRef={formRef}
        >
            <ImageUploadSection
                title="Illusztráció"
                description="Töltsön fel tetszőleges számú képet"
                uploadDescription="A feltöltött kép lesz látható az eseménynél az előadás képe helyett."
                onUpload={onUpload}
                customImageOptions={customImageOptions}
                setCustomImageOptions={setCustomImageOptions}
                customImage={customImage}
                setCustomImage={setCustomImage}
                setUploadedImages={setUploadedImages}
                allowMultiple={false}
            />
            <hr />
            <EventDataFields control={control} errors={errors}></EventDataFields>

            <EventPricing
                control={control}
                errors={errors}
                seatSellingMode={seatSellingMode}
                selectedPrice={selectedPrice}
                setSelectedPrice={setSelectedPrice}
                selectedPriceIndex={selectedPriceIndex}
                setSelectedPriceIndex={setSelectedPriceIndex}
                ticketData={ticketData}
                setTicketData={setTicketData}
                locationData={locationData}
                setValue={setValue}
                defaultPrice={defaultPrice}
                defaultIncrement={defaultIncrement}
                eventId={initialData?.event_id}
            />
            <ConfirmDialog />
        </CustomForm>
    )
}
